import React, { createContext, useContext, useState, useEffect } from 'react';
import printerService from '../services/printerService';

const PrinterContext = createContext();

export const usePrinter = () => {
  const context = useContext(PrinterContext);
  if (!context) {
    throw new Error('usePrinter debe ser usado dentro de un PrinterProvider');
  }
  return context;
};

export const PrinterProvider = ({ children }) => {
  const [isConnected, setIsConnected] = useState(true);
  const [printerConfig, setPrinterConfig] = useState({
    type: 'thermal_label',
    connection: 'usb',
    model: 'RONGTA RP425 (ZPL 203DPI)',
    paperWidth: '58',
    defaultLabelSize: '50x25',
    emulation: 'ZPL',
    autocut: false,
    ipAddress: '',
    port: '9100'
  });
  const [error, setError] = useState(null);

  useEffect(() => {
    // Cargar configuración guardada
    const config = printerService.getLocalConfig();
    if (config) {
      setPrinterConfig(prev => ({ ...prev, ...config }));
    }
  }, []);

  // Función para conectar con la impresora
  const connectPrinter = async (config) => {
    try {
      setError(null);
      setPrinterConfig(config);
      printerService.saveLocalConfig(config);
      setIsConnected(true);
      return true;
    } catch (err) {
      setError(err.message);
      setIsConnected(false);
      return false;
    }
  };

  // Función para desconectar la impresora
  const disconnectPrinter = () => {
    setIsConnected(false);
    setError(null);
  };

  // Función para actualizar la configuración
  const updateConfig = (newConfig) => {
    setPrinterConfig(prev => {
      const merged = { ...prev, ...newConfig };
      printerService.saveLocalConfig(merged);
      return merged;
    });
  };

  const value = {
    isConnected,
    printerConfig,
    error,
    connectPrinter,
    disconnectPrinter,
    updateConfig
  };

  return (
    <PrinterContext.Provider value={value}>
      {children}
    </PrinterContext.Provider>
  );
};